import { ContractWithContractLinesInputType } from '@/graphql/contracts/_generated_/contracts';
import { 
  ContractLineSelectionPayload 
} from '@/pages/ContractDetails/ContractLines/components/ContractLinesGrid/linesSelectionObservable';

export interface SelectedLine {
  id: string;
  payload: ContractLineSelectionPayload;
}

export function groupSelectedLinesByContract(selectedLines: SelectedLine[]): ContractWithContractLinesInputType[] {
  const contractsMap = new Map<string, any[]>();
  
  selectedLines.forEach(line => {
    const contractLine = line.payload.contractLine;
    const contractId = (contractLine as any).contractId || (contractLine as any).contractID;
    if (!contractsMap.has(contractId)) {
      contractsMap.set(contractId, []);
    }
    contractsMap.get(contractId)!.push({ contractLineID: line.id });
  });

  return Array.from(contractsMap.entries()).map(([contractId, contractLines]) => ({
    contractId,
    contractLines
  }));
}
